import {createContext} from "react"

interface Config{
    client_name : string,
    client_display_name : string,
    modal_confirm_button_label : string,
    country : 'de' | 'at' | 'ch',
    base_asset_url : string,
    plz_validation : (plz : string) => boolean,
    foerderung : boolean,
    uid?: string,
    contact_url?: string,
    logo_url?: string,
}

export const ConfigContext = createContext<Config>({
    client_name : "hornbach-at",
    client_display_name : "Hornbach",
    modal_confirm_button_label : "übernehmen",
    country : 'at',
    base_asset_url :` https://esr.fe-bis.de/at/hornbach/`,
    plz_validation : (plz : string) => plz.length == 4,
    foerderung : false,
});


